import React from 'react';
import { fabric } from 'fabric';
import HelperServices from '../../services/CommonServices';
import { Constants } from '../../data/Constants'

class Perspectivecrop extends React.Component {
  constructor() {
    super();
    this.state = {
      file: null
    }
  }
  componentDidMount() {
    const self = this
    var canvas = new fabric.Canvas('cropimg-canvas', { selection: false });
    canvas.hoverCursor = 'auto';
    let img = new Image();
    img.src = this.props.src
    canvas.setDimensions({ width: img.width, height: img.height });
    this.setState({
      x0: img.width / 5,
      x1: img.width - img.width / 5,
      x2: img.width - img.width / 5,
      x3: img.width / 5,
      y0: img.height / 5,
      y1: img.height / 5,
      y2: img.height - img.height / 5,
      y3: img.height - img.height / 5,
    }, () => {
      fabric.Image.fromURL(this.props.src, function (backgroundImg) {
        canvas.add(backgroundImg);
        backgroundImg.sendToBack()
        canvas.renderAll()
      }, {
        lockMovementX: true,
        lockMovementY: true,
        selectable: false
      });
      function makeCircle(left, top, line1, line2) {
        var c = new fabric.Circle({
          left: left,
          top: top,
          strokeWidth: 5,
          radius: 12,
          fill: '#fff',
          stroke: '#666',
          hoverCursor: 'move',
          originX: 'center',
          originY: 'center'
        });
        c.hasControls = c.hasBorders = false;
        c.line1 = line1;
        c.line2 = line2;
        return c;
      }

      function makeLine(coordinates) {
        return new fabric.Line(coordinates, {
          fill: 'red',
          stroke: 'red',
          strokeWidth: 5,
          selectable: false,
          evented: false,
        });
      }

      var line = makeLine([this.state.x0, this.state.y0, this.state.x1, this.state.y1]),
        line2 = makeLine([this.state.x1, this.state.y1, this.state.x2, this.state.y2]),
        line3 = makeLine([this.state.x2, this.state.y2, this.state.x3, this.state.y3]),
        line4 = makeLine([this.state.x3, this.state.y3, this.state.x0, this.state.y0]);
      canvas.add(line, line2, line3, line4);
      this.c1 = makeCircle(line.get('x1'), line.get('y1'), line4, line)
      this.c2 = makeCircle(line.get('x2'), line.get('y2'), line, line2)
      this.c3 = makeCircle(line2.get('x2'), line2.get('y2'), line2, line3)
      this.c4 = makeCircle(line3.get('x2'), line3.get('y2'), line3, line4)
      canvas.add(
        this.c1,
        this.c2,
        this.c3,
        this.c4
      );



      canvas.on('object:moving', function (e) {
        var obj = e.target;
        // if object is too big ignore
        if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
          return;
        }
        obj.setCoords();
        // top-left  corner
        if (obj.getBoundingRect().top < - 12 || obj.getBoundingRect().left < - 12) {
          obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top - 12);
          obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left - 12);
        }
        // bot-right corner
        if (obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height + 12 || obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width + 12) {
          obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top + 12);
          obj.left = Math.min(obj.left, obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left + 12);
        }
        var p = e.target;
        p.line1 && p.line1.set({ 'x2': p.left, 'y2': p.top });
        p.line2 && p.line2.set({ 'x1': p.left, 'y1': p.top });
        p.line3 && p.line3.set({ 'x1': p.left, 'y1': p.top });
        p.line4 && p.line4.set({ 'x1': p.left, 'y1': p.top });
        canvas.renderAll();
        self.setState({
          x0: self.c1.left,
          y0: self.c1.top,
          x1: self.c2.left,
          y1: self.c2.top,
          x2: self.c3.left,
          y2: self.c3.top,
          x3: self.c4.left,
          y3: self.c4.top
        })
      });
      this.createFile(this.props.src)
    })

  }

  async createFile(src) {
    let response = await fetch(src);
    let data = await response.blob();
    let metadata = {
      type: 'image/jpeg'
    };
    let file = new File([data], "image.jpg", metadata)
    this.setState({ file: file })
  }

  buttonclicked = () => {
    const data = new FormData();
    data.append('image', this.state.file)
    let tl = { "x": this.state.x0, "y": this.state.y0 }
    let tr = { "x": this.state.x1, "y": this.state.y1 }
    let bl = { "x": this.state.x3, "y": this.state.y3 }
    let br = { "x": this.state.x2, "y": this.state.y2 }

    data.append("perspectiveCoordinate", JSON.stringify({ "tl": tl, "tr": tr, "bl": bl, "br": br }))
    HelperServices.cropImage(data)
      .then(response => {
        this.props.cropComplete(response)
      })
      .catch((error) => {
        let errorMessage = ""
        try {
            errorMessage = error.data.message
        } catch (error) {
            errorMessage = Constants.generalErrorMessage
        }
        this.setState({
            modalHeading: "Error in croping Image",
            modalInfo: errorMessage
        })
        this.handleShow()
    })
  }

  render() {
    return (
      <div className="outer-div">
        <canvas id="cropimg-canvas"></canvas>
      </div>
    );
  }
}

export default Perspectivecrop;
